import { Constants } from '../../constants/constants';
import { Component, OnInit } from '@angular/core';

import { EstructuraControlService } from '../../servicios/estructura-control.service';
import { SetFormService } from '../../servicios/set-form.service';
import { FormTextbox } from '../../model-form/form-textbox';
import { FormDropdown } from '../../model-form/form-dropdown';
import { EstructuraBase } from '../../model-form/estructura-base';
import { Utils } from '../../utils/utils';

@Component({
  selector: 'app-reporte-personas',
  templateUrl: './reporte-personas.component.html',
  styleUrls: ['./reporte-personas.component.css']
})
export class ReportePersonasComponent implements OnInit {
  items: EstructuraBase<any>[];
  descripcion: string;
  idFormulario = 1;
  parametrosDestino: any[] = [];
  procedimientoDestino: string = '';
  infoReporte: any;

  constructor(
    servicioFormulario: SetFormService,
    public ruta: Utils,
    private formatFormulario: Utils
  ) {
    this.descripcion = 'Reporte Persona';
    let response: any;

    servicioFormulario.getFormularioReporte(this.idFormulario).subscribe(data => {
      this.procedimientoDestino = data[0].procedimientoDestino;
      response = this.formatFormulario.formatFormulario(data);
      this.items = response.arrayDatos;
      this.parametrosDestino = response.parametros;

      return this.items.sort((a, b) => a.order - b.order);
    });
  }

  ngOnInit() {}

  salidaReporte($event) {
    this.salidaReporte = $event;
    alert(JSON.stringify(this.salidaReporte));
  }
}
